import React from 'react'
import {Row, Col, CheckmarkIcon, withResponsiveHelper} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {times} from 'ramda'

import {
  CircledNumber,
  PositionedRow,
  ProgressLine,
  StepsLabel,
  StyledItemCol,
  Wrapper,
} from './styles'

type ProgressStepsProps = {
  totalSteps: number
  currentStep: number
  labelSteps?: string[]
  isSmOrSmaller?: boolean
  horizontalAlignment?: string
}

export const ProgressSteps: React.FC<ProgressStepsProps> = ({
  totalSteps,
  currentStep,
  labelSteps,
  isSmOrSmaller = false,
  horizontalAlignment = 'start',
}) => {
  const {t} = useTranslation('charon')

  return (
    <Wrapper>
      <Row
        mdMb={32}
        alignItems="center"
        justifyContent={isSmOrSmaller ? 'start' : horizontalAlignment}
      >
        {times(
          count => (
            <React.Fragment key={`progress-${count}`}>
              <Col auto mb={8}>
                <PositionedRow alignItems="center" isMobileResponsive={totalSteps > 2}>
                  <StyledItemCol col="auto">
                    <CircledNumber
                      completed={currentStep > count + 1}
                      enabled={currentStep === count + 1}
                    >
                      {currentStep > count + 1 ? <CheckmarkIcon /> : count + 1}
                    </CircledNumber>
                  </StyledItemCol>
                  <StyledItemCol col="auto" isMobileResponsive={totalSteps > 2}>
                    <StepsLabel enabled={currentStep === count + 1}>
                      {labelSteps
                        ? t(labelSteps[count])
                        : `${t('progress-steps.step.text')} ${count + 1}`}
                    </StepsLabel>
                  </StyledItemCol>
                </PositionedRow>
              </Col>
              <Col col={totalSteps > 2 && isSmOrSmaller ? 12 : 'auto'} mb={8}>
                {count + 1 < totalSteps && (
                  <ProgressLine
                    completed={currentStep > count + 1}
                    isMobileResponsive={totalSteps > 2 && isSmOrSmaller}
                  />
                )}
              </Col>
            </React.Fragment>
          ),
          totalSteps
        )}
      </Row>
    </Wrapper>
  )
}

export default withResponsiveHelper(ProgressSteps)
